export enum ESuit {
  SPADE = 's',
  HEART = 'h',
  DIAMOND = 'd',
  CLUB = 'c',
}
